import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";
import { useExtensionContext } from "../modules/extension/ExtensionContext";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useDeleteAttachment = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { refetchAttachments, profileNotesRefetch } = useExtensionContext();
    const deleteAttachment = async ({ attachmentId }) => {
        setLoading(true);
        setError(null);
        try {
            const response = await post({
                fn: "deleteAttachment",
                attachmentId,
            }).then(() => {
                //refetchProfile();
                refetchAttachments();
                profileNotesRefetch({ rowsPerPage: 100 });
            });
            toast.success("Attachment deleted.");

            return response;
        } catch (err) {
            toast.error(apiErrorText(err));
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, deleteAttachment };
};

export default useDeleteAttachment;
